module.exports = __webpack_public_path__ + "static/media/19ESCAP40.2647172d.jpg";